<p-dialog
  [visible]="updates.dialogVisible()"
  (visibleChange)="onVisibleChange($event)"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="!updates.reloading()"
  [closeOnEscape]="!updates.reloading()"
  [dismissableMask]="false"
  [blockScroll]="true"
  [baseZIndex]="10000"
  [style]="{ width: 'min(480px, 94vw)' }"
  styleClass="app-update-dialog"
  appendTo="body"
  ariaLabelledBy="app-update-dialog-title">
  <ng-template pTemplate="header">
    <div class="app-update-dialog__header">
      <span class="app-update-dialog__icon" aria-hidden="true">
        <i class="pi pi-sparkles"></i>
      </span>
      <div class="app-update-dialog__heading">
        <span class="app-update-dialog__eyebrow">{{ 'APP_UPDATE.EYEBROW' | translate }}</span>
        <span id="app-update-dialog-title" class="app-update-dialog__title">{{ 'APP_UPDATE.TITLE' | translate }}</span>
      </div>
    </div>
  </ng-template>

  <div class="app-update-dialog__body">
    <p class="app-update-dialog__text">{{ 'APP_UPDATE.MESSAGE' | translate }}</p>

    <div class="app-update-dialog__warning" role="note">
      <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
      <div>
        <strong>{{ 'APP_UPDATE.WARNING_TITLE' | translate }}</strong>
        <span>{{ 'APP_UPDATE.WARNING_MESSAGE' | translate }}</span>
      </div>
    </div>

    <ul class="app-update-dialog__benefits">
      <li><i class="pi pi-check-circle" aria-hidden="true"></i>{{ 'APP_UPDATE.BENEFIT_FIXES' | translate }}</li>
      <li><i class="pi pi-check-circle" aria-hidden="true"></i>{{ 'APP_UPDATE.BENEFIT_FAST' | translate }}</li>
    </ul>
  </div>

  <ng-template pTemplate="footer">
    <div class="app-update-dialog__actions">
      <p-button
        [label]="'APP_UPDATE.LATER' | translate"
        severity="secondary"
        [text]="true"
        [disabled]="updates.reloading()"
        (onClick)="updates.postpone()"
        styleClass="app-update-dialog__later" />
      <p-button
        [label]="(updates.reloading() ? 'APP_UPDATE.UPDATING' : 'APP_UPDATE.UPDATE_NOW') | translate"
        icon="pi pi-refresh"
        [loading]="updates.reloading()"
        (onClick)="updates.applyUpdate()"
        styleClass="app-update-dialog__update" />
    </div>
  </ng-template>
</p-dialog>
